import { l } from '@manychat/manyui'

import { ReasonTypes } from './constants/notifyReasonConstants'

export const getBlockSubtitleByType = (type: ReasonTypes | null) => {
  if (!type) {
    return ''
  }

  return type === ReasonTypes.ONE_TIME
    ? l.translate(
        'By clicking “Notify Me”, you may receive a message from Recurring notification in the future about this topic.',
      )
    : l.translate('Want to get additional messages from us? You can opt out at any time.')
}
